import { Modal } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import styles from "./ActionModal.module.scss"

const ActionModal = ({ show, setShow, id }: any) => {
  const navigate = useNavigate()
  const handleCloseModal = () => {
    setShow(!show)
    navigate(`/${id}`)
  }

  const handleStayHere = () => {
    setShow(!show)
  }

  return (
    <Modal
      className={`${styles.addPopup} event-page__invite-modal`}
      show={show}
      onHide={() => setShow(!show)}
    >
      <Modal.Header className={styles.close} closeButton></Modal.Header>
      <Modal.Body>
        <div className={styles.body}>
          <h2 className={`caption ${styles.caption}`}>
            Contacts were successfully added to the event
          </h2>

          <div className={styles.controls}>
            <span className="btn btn-simple" onClick={handleStayHere}>
              Stay Here
            </span>
            <button onClick={handleCloseModal} className="btn btn-dark">
              Go To Event
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default ActionModal
